import { createReducer, on } from "@ngrx/store";
import { moduleChanged, moduleId } from "../actions/module-info.actions";
//reducer is used to store values in global store -> StoreModule.forRoot({}, {}) in src/app/app.module.ts
//reducer starting state
const initialState = null;
export const moduleInfoReducer = createReducer(initialState, on(moduleId, (state, action) => action.value));
export const moduleChangedReducer = createReducer(initialState, on(moduleChanged, (state, action) => action.value));
